import { confirmTransactionWithRetry } from '@prediction-market/providers';
import { SendTransactionOptions } from '@solana/wallet-adapter-base';
import { Wallet } from '@solana/wallet-adapter-react';
import { Connection, Transaction } from '@solana/web3.js';

import { connection, getProvider } from '@/constants/solana';

export const sendSolanaTransaction = async (
  tx: Transaction,
  wallet: Wallet | null,
  sendTransaction: (
    tx: Transaction,
    connection: Connection,
    options?: SendTransactionOptions,
  ) => Promise<string>,
  options?: SendTransactionOptions,
): Promise<string> => {
  if (!wallet || !wallet.adapter.publicKey) {
    throw new Error('Wallet not found');
  }

  const provider = getProvider(wallet);
  if (provider) {
    console.log('using phantom sign and send');
    const { blockhash } = await connection.getLatestBlockhash();
    tx.recentBlockhash = blockhash;
    tx.feePayer = wallet.adapter.publicKey;
    const { signature } = await provider.signAndSendTransaction(tx, options);
    await confirmTransactionWithRetry(connection, signature);
    return signature as string;
  }

  const signature = await sendTransaction(tx, connection, options);
  await confirmTransactionWithRetry(connection, signature);
  return signature;
};
